import React from 'react';
import UDIDropdownfield from "./UDIDropdownfield.js"

const IssuingAgency = ({
	UDI,
	setUDI,
	forceIsEditing = null
}) => {

	const fieldName = "IssuingAgency";
	const fieldTitle = "Issuing Agency";
	const LOV = [
		{ key: "", value: "" },
		{ key: "GS1", value: "GS1" },
		{ key: "HIBCC", value: "HIBCC" },
		{ key: "ICCBBA", value: "ICCBBA" }
	];

	return <>
		<UDIDropdownfield UDI={UDI} setUDI={setUDI} fieldTitle={fieldTitle} fieldName={fieldName} LOV={LOV} forceIsEditing={forceIsEditing} />
	</>											  
}


export default IssuingAgency;


